import { useState, useEffect } from 'react';

export const useLiteWebView = () => {
  const [isLite, setIsLite] = useState(false);
  useEffect(() => {
    const qs = new URLSearchParams(window.location.search);
    setIsLite(qs.get('app') === '1');
  }, []);
  return isLite;
};

export const withAppFlag = (url: string, isLite: boolean) => {
  if (!isLite) return url;
  const u = new URL(url, window.location.origin);
  u.searchParams.set('app', '1');
  return (
    u.pathname +
    (u.search ? `?${u.searchParams.toString()}` : '') +
    (u.hash ?? '')
  );
};
